import { PropsWithChildren } from "react";
import { TextProps } from "../data";
import { fontWeightEnum } from "../enumerations/fontWeightEnum";
import styles from "./style.module.scss";

const H6: React.FC<
  PropsWithChildren & TextProps & React.HTMLAttributes<HTMLHeadingElement>
> = ({
  children,
  weight = "normal",
  color = "rgba(0, 0, 0, 0.88)",
  ...props
}) => {
  return (
    <h6
      {...props}
      className={`${styles.h6} ${props.className}`}
      style={{
        fontWeight: fontWeightEnum[weight],
        color: color,
        ...props.style,
      }}
    >
      {children}
    </h6>
  );
};

export default H6;
